const useToastMethods = (state, defaultTimeout) => {
  const showToast = (message, variant, timeout = defaultTimeout) => {
    const value = {
      children: message,
      variant
    };
    state.add(value, { timeout });
  };
  return {
    error: (message, timeout) => showToast(message, "error", timeout),
    success: (message, timeout) => showToast(message, "success", timeout),
    info: (message, timeout) => showToast(message, "info", timeout),
    warning: (message, timeout) => showToast(message, "warning", timeout)
  };
};
export {
  useToastMethods
};
